<template>
  <div :id="name" />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    data: {
      type: Number|String,
      default: 0
    },
    title: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: 'gauge'
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    // this.$nextTick(() => {
    this.setOption();
    // });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    data(val) {
      this.setOption(val);
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOption(this.data);
    },
    setOption(data) {
      var chartDom = document.getElementById(this.name);
      var myChart = echarts.init(chartDom);
      let option = {
        series: [
          {
            type: "gauge",
            radius: '60%',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: "#48A1FF"
              },
              color: '#48A1FF'
            },
            axisLine: {
              lineStyle: {
                width: 20
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 30
            },
            data: [
              {
                value: this.data,
                color: '#F2F2F2',
                title: {
                  offsetCenter: ["0%", "-120%"]
                },
                name: this.title,
                detail: {
                  offsetCenter: ["0%", "0%"]
                },
                itemStyle: {
                    color: '#48A1FF'
                }
              }
            ],
            title: {
              fontSize: 14
            },
            detail: {
              width: 30,
              height: 14,
              fontSize: 14,
              color: "#6999f5",
              borderColor: "auto",
              borderRadius: 20,
              borderWidth: 0,
              formatter: "{value}%"
            }
          }
        ]
      };
    //   setInterval(function() {
    //     // option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
    //     myChart.setOption(option, true);
    //   }, 2000);
      option && myChart.setOption(option);
    }
  }
};
</script>
